import api from "./index";

export const startOrderReportService = async (token, data) => {
  return await api.post(`/async/order-report`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getOrderReportStatusService = async (token, reportId) => {
  return await api.get(`/async/order-report/${reportId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
